module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/192q7Wl/tc-custom/9780795320729.jpg?1704285892694",
      "alt": "This image is the cover for the book At the Sign of the Golden Pineapple, The Love and Temptation Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("At the Sign of the Golden Pineapple, The Love and Temptation Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A lady’s sensational sweet shop causes a scandal among the "), _c('i', [_vm._v("ton")]), _vm._v(" in this Regency romance by the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("When Miss Henrietta Bascombe decides to eschew marriage in pursuit of a trade, the pronouncement causes quite a stir. But Henrietta is determined to turn her pittance of an inheritance into a fortune. And she plans to do so by opening a London sweet shop to rival the famous Gunther's! "), _c('br'), _c('br'), _vm._v("Hanging out her shingle—the traditional confectioners sign of a golden pineapple—Henrietta soon earns the custom of the entire "), _c('i', [_vm._v("ton")]), _vm._v(". But the proud Earl of Carrisdowne takes exception to his younger brother ogling the girls behind Bascombe's counter. The earl intends to see Miss Bascombe close up shop and soon. But the more he tangles with the fiery-eyed proprietor, the more he finds her as irresistible as her famous treats . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      M. C. Beaton\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    RosettaBooks, LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0